import React from "react";
import {
  blackShade19,
  blueColor04,
  border25,
  errorTextColor,
  greyColor21,
  greyColor40,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { Box, Checkbox, Grid, Stack, Typography } from "@mui/material";
import SelectWithLabel from "../../../components/Input/SelectWithLabel";

function SelectVariantForm({
  ondcList,
  selectedVariant,
  onValueChange,
  onTagValueChange,
}) {
  return (
    <Box sx={styles.card}>
      <Typography sx={styles.title}>Select Variants</Typography>
      <Grid container spacing={2}>
        <Grid item xs={8} md={3.5}></Grid>
        <Grid item xs={4}>
          <Typography
            color={greyColor40}
            fontSize={{ md: 13, xs: 12 }}
            mb="0 !important"
          >
            Tags (Min 1)
          </Typography>
          <Typography color={greyColor40} fontSize={{ md: 11, xs: 12 }}>
            This value will be used to identify the variant along with product
            name
          </Typography>
        </Grid>
      </Grid>
      <Stack gap={2}>
        <SelectVariantCard
          label="Variant 1"
          menuList={ondcList}
          value={selectedVariant?.variant1?.value?.displayName}
          tagValue={selectedVariant?.variant1?.tag}
          onValueChange={(value) => onValueChange("variant1", value)}
          onTagValueChange={() =>
            onTagValueChange("variant1", !selectedVariant?.variant1?.tag)
          }
          error={selectedVariant?.errors?.variant1}
        />
        <SelectVariantCard
          label="Variant 2"
          menuList={ondcList}
          value={selectedVariant?.variant2?.value?.displayName}
          tagValue={selectedVariant?.variant2?.tag}
          onValueChange={(value) => onValueChange("variant2", value)}
          onTagValueChange={() =>
            onTagValueChange("variant2", !selectedVariant?.variant2?.tag)
          }
          error={selectedVariant?.errors?.variant2}
          disabled={!selectedVariant?.variant1?.value || ondcList?.length == 1}
        />
      </Stack>
    </Box>
  );
}

export default SelectVariantForm;

const SelectVariantCard = ({
  menuList,
  value,
  onValueChange,
  label,
  onTagValueChange,
  tagValue,
  error,
  disabled,
}) => {
  return (
    <Grid container spacing={2} display={"flex"} alignItems={"flex-end"}>
      <Grid item xs={2.6} md={1}>
        <Typography color={greyColor40} fontSize={{ md: 13, xs: 12 }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={5.4} md={2.5}>
        <SelectWithLabel
          value={value}
          menuList={menuList || []}
          onValueChange={onValueChange}
          valueSelector={"displayName"}
          returnFullItem
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={2} md={1}>
        <Checkbox
          checked={tagValue || false}
          onChange={onTagValueChange}
          sx={styles.checkbox}
          disabled={disabled}
        />
      </Grid>
      {error && (
        <Grid item xs={12}>
          <Typography
            fontSize={12}
            fontWeight={500}
            textAlign="left"
            color={"red"}
            ml={"8%"}
            mt={-1.5}
          >
            {error}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "10px 15px",
    mb: 2,
    mt: 1,
  },

  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    // mb: "10px",
    color: blackShade19,
  },

  checkbox: {
    color: greyColor21,
    p: 0,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: blueColor04,
    },
  },
};
